/**
 * Whose activity the dashboard and notification feeds show.
 *
 * Everyone sees their own: a feed of what you did is useful to anyone, and
 * the server lets every member read it (scope=mine). Someone who holds
 * audit.read — an organization administrator — may switch to everyone's, and
 * that choice is remembered for them in this organization, in this browser
 * (workspacePrefs). Without audit.read the answer is always 'mine', whatever
 * is stored, so a stale preference can never ask the server for a 403.
 */
import { useTenant } from '../context/TenantContext.jsx';
import { useAuth } from '../context/AuthContext.jsx';
import { useShell } from '../layouts/ShellContext.jsx';

export function useActivityScope() {
  const { can, loading } = useTenant();
  const { user } = useAuth();
  const shell = useShell();

  const canSeeEveryone = can('audit.read');
  const scope = canSeeEveryone && shell?.prefs.activityScope === 'all' ? 'all' : 'mine';

  return {
    scope,
    setScope: (value) => shell?.prefs.setActivityScope(value),
    canSeeEveryone,
    selfId: user?.id ?? null,
    /** False until permissions are known: fetching before then would ask for the wrong scope. */
    ready: !loading,
  };
}
